import { ISalesDocument } from '@cemex-core/cmx-api';
import { TranslateService } from '@ngx-translate/core';
import { ContractBalance } from '@ordersnproducts/modules/order-builder/modules/specification/models/contract-balance';
import { SelectOptionI } from '../modules/configurable-form/components/form-multiselect/models/select-option-i';

export function loadAvailableContracts(
  contracts: ISalesDocument[],
  contractsBalance: { [salesDocumentItemId: string]: ContractBalance },
  translate: TranslateService,
  withBalanceOnly = true,
): SelectOptionI[] {
  if (withBalanceOnly) {
    // Filter out contracts without balance that are supposed to have
    contracts = contracts.filter(contract => {
      if (contract.hasBalance) {
        return !!contractsBalance[contract.salesDocumentItemId];
      } else {
        return true;
      }
    });
  }

  // Return select options
  return contracts.map(salesDocument => {
    return {
      id: salesDocument.salesDocumentItemId,
      name: description(salesDocument, contractsBalance, translate),
    };
  });
}

function description(
  salesDocument: ISalesDocument,
  contractsBalance: { [salesDocumentItemId: string]: ContractBalance },
  translate: TranslateService,
): string {
  const name = `${translate.instant('views.specifications.contract')} ${salesDocument.salesDocumentCode}`;
  const remainingVolume = contractsBalance[salesDocument.salesDocumentItemId];
  if (remainingVolume) {
    return `${name}  ‏‏‎  ‏‏‎  ‏‏‎  ${translate.instant('views.specifications.remaining_volume')}
    ${remainingVolume.amount} ${remainingVolume.unitOfMeasure.unitCode}`;
  } else {
    return name;
  }
}
